<template>
    <b-dropdown-item @click="submit">
        Enable Default 2FA
        <form ref="form" :action="action" method="POST" class="d-none">
            <input type="hidden" name="_token" :value="csrfToken">
        </form>
    </b-dropdown-item>
</template>

<script>
export default {
    props: {
        action: {
            type: String,
            required: true,
        },
    },
    computed: {
        csrfToken() {
            return document.querySelector('meta[name="csrf-token"]').getAttribute('content');
        },
    },
    methods: {
        submit() {
            this.$refs.form.submit();
        },
    },
};
</script>
